// Agent ka card: plan tab, avatar, naam + live status, business, number.
// (Naam "InfoCard": Dashboard me pehle se ek alag PounceAgentCard hai.)
import React from "react";
import { useNavigate } from "react-router-dom";
import InfoTooltip from "../../TooltipSteps/Tooltip";
import styles from "./PounceAgentInfoCard.module.css";
import { PLAN_LABELS, planLabel, formatPhone, avatarSrc } from "../../../utils/pounceAgentHelpers";

const PounceAgentInfoCard = ({ agent, agentId }) => {
  const navigate = useNavigate();

  return (
    <section className={styles.agentCard} aria-label="Agent">
      <span className={styles.planTab}>{planLabel(agent.plan, agent.deal) || PLAN_LABELS.payg}</span>
      {/* Receptionist ka edit wizard (/edit-language → … → /fast-agent-detail)
          Pounce agent ko receptionist page pe utaar deta — Pounce ka apna
          edit screen banne tak band. */}
      <button
        type="button"
        className={styles.editBtn}
        disabled
        title="Coming soon"
        aria-label="Edit agent (coming soon)"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 20h4L19 9l-4-4L4 16v4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M13.5 6.5l4 4" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      </button>

      <div className={styles.avatarCol}>
        <img className={styles.avatar} src={avatarSrc(agent.avatar)} alt="" />
        <span className={styles.langPill}>
          {String(agent.agentLanguage || "English").split(" ")[0].toUpperCase()}
        </span>
      </div>

      <div className={styles.agentInfo}>
        <h1 className={styles.agentName}>
          {String(agent.agentName || "").toUpperCase()}
          <span className={agent.live ? styles.liveOn : styles.liveOff}>
            <span className={styles.liveDot} aria-hidden="true" />
            {agent.live ? "Live" : "Paused"}
          </span>
        </h1>
        <p className={styles.businessName}>{agent.businessName}</p>
        {agent.callerNumber ? (
          <div className={styles.numberRow}>
            <span className={styles.number}>
              {formatPhone(agent.callerNumber)}
            </span>
            {agent.usesSharedPool && (
              <InfoTooltip content="Your calls go out from the Rexpt calling pool. We manage and rotate these numbers so they stay trusted and don't get spam-flagged, so your leads actually pick up. Each lead always hears from the same number." />
            )}
          </div>
        ) : (
          <div className={styles.assignNumberRow}>
            <button
              type="button"
              className={styles.assignNumberBtn}
              onClick={() => {
                sessionStorage.setItem("SelectAgentId", agentId);
                sessionStorage.setItem("SelectAgentBusinessId", agent.businessId);
                sessionStorage.setItem("SelectAgentRole", "pounce");
                navigate("/receptionist-number", {
                  state: {
                    agentId: agentId,
                    businessId: agent.businessId,
                    fromPounce: true,
                  },
                });
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
              <span>Assign Number</span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PounceAgentInfoCard;
